import React from "react";
import { CVEdit } from "../../../Modules/CVEdit";

export default () => {
  return <CVEdit />;
};
